module.exports = __webpack_public_path__ + "img/MOS.5eb0c1c1.png";